<div class="flex-content">

  <div *ngFor="let pro of project" class="content col-sm container-fluid">
    
    <div class="project-img-box col-12">
      <img default="./../../../../assets/Contents/imgs/no_image.jpg" [srcset]=" imgPath + pro.teaser_img" [src]=" imgPath + pro.teaser_img">
    </div>

    <div class="row no-gutters">


      <div class="col-12">


        <div class="col-12">
          <p>
            <span style="color:orange">
              {{pro.status}}
            </span>
            <span style="font-size:1rem">
              / {{pro.type}}
            </span>
          </p>
        </div>

        <div class="col-12">
          <p>{{pro.start}} - {{pro.end}}</p>
        </div>

        <div class="project-desc col-12">
          <p class="display-4">{{pro.fullname}}</p>
          <p class="project-desc-text" [innerHTML]='pro.description'></p>
        </div>

        <!-- <div class="project-img-box">
            <img default="./../../../../assets/Contents/imgs/no_image.jpg" [srcset]=" imgPath + pro.teaser_img" [src]=" imgPath + pro.teaser_img">
          </div> -->

      </div>

      <div class="divider"></div>




      <div class="col-12 project-manager">
        <h5 class="column-title">Members</h5>
        <!-- <h2 class="people-status col-sm-12">
          Members
        </h2> -->

        <div class="box-flex row">
          <!-- <div [ngClass]="{'teamLeader': (person.status.length > 0) }" (click)="navigateTo('people', person.id)" *ngFor="let person of pro.people" class="people-box pad col-sm-12 col-md-6"> -->
          <div (click)="navigateTo('people', person.id)" *ngFor="let person of pro.people" class="people-box pad col-sm-12 col-md-6">
            <div class="people-img">
              <div class="people-img-box">
                <img default="./../../../../assets/Contents/imgs/no_image.jpg" [srcset]=" imgPath + person.img" [src]=" imgPath + person.img">
              </div>
            </div>

            <h5 class="people-text" >
              <p class="menu02">name</p>
              {{person.name}} 
              <p class="menu02">email</p>
              {{person.email}}
            </h5>
          </div>
        </div>

      </div>




      <div class="col-12 project-manager">
        <h5 class="column-title">Partners</h5>
        <!-- <h2 class="people-status col-sm-12">
          Partners
        </h2> -->

        <div class="box-flex row">
          <!-- <div [ngClass]="{'teamLeader': (person.status.length > 0) }" (click)="navigateTo('people', person.id)" *ngFor="let person of pro.people" class="people-box pad col-sm-12 col-md-6"> -->
          <div (click)="navigateTo('partner', 0, partner.link)" *ngFor="let partner of pro.partners" class="people-box pad col-sm-12 col-md-6">
            <div class="people-img">
              <div class="people-img-box">
                <img default="./../../../../assets/Contents/imgs/no_image.jpg" [srcset]=" imgPath + partner.logo" [src]=" imgPath + partner.logo">
              </div>
            </div>

            <h5 class="people-text" >
              <p class="menu02">name</p>
              {{partner.name}} 
            </h5>
          </div>
        </div>

      </div>

      <div class="col-12 project-manager">
        <h5 class="column-title">Funding</h5>
        <!-- <h2 class="people-status col-sm-12">
          Partners
        </h2> -->

        <div class="box-flex row">
          <!-- <div [ngClass]="{'teamLeader': (person.status.length > 0) }" (click)="navigateTo('people', person.id)" *ngFor="let person of pro.people" class="people-box pad col-sm-12 col-md-6"> -->
          <div (click)="navigateTo('partner', 0, pro.funding.link)" *ngIf="pro.funding" class="people-box pad col-sm-12 col-md-6">
            <div class="people-img">
              <div class="people-img-box">
                <img default="./../../../../assets/Contents/imgs/no_image.jpg" [srcset]=" imgPath + pro.funding.logo" [src]=" imgPath + pro.funding.logo">
              </div>
            </div>

            <h5 class="people-text" >
              <p class="menu02">name</p>
              {{pro.funding.name}} 
            </h5>
          </div>
        </div>

      </div>


      <div class="col-12">
        <h5 class="column-title col-12">Related Videos</h5>

        <div *ngIf="demo1 != null" class="video-box col-sm-6 col-md-6">
          <div class="embed-responsive embed-responsive-16by9 ">
            <iframe class="videoURL embed-responsive-item" [src]="demo1" allowfullscreen></iframe>
          </div>
        </div>

        <div *ngIf="demo2 != null" class="video-box col-sm-6 col-md-6">
          <div class="embed-responsive embed-responsive-16by9 ">
            <iframe class="videoURL embed-responsive-item" [src]="demo2" allowfullscreen></iframe>
          </div>
        </div>

        <div *ngIf="demo3 != null" class="video-box col-sm-6 col-md-6">
          <div class="embed-responsive embed-responsive-16by9 ">
            <iframe class="videoURL embed-responsive-item" [src]="demo3" allowfullscreen></iframe>
          </div>
        </div>

        <div *ngIf="demo4 != null" class="video-box col-sm-6 col-md-6">
          <div class="embed-responsive embed-responsive-16by9 ">
            <iframe class="videoURL embed-responsive-item" [src]="demo4" allowfullscreen></iframe>
          </div>
        </div>

        <div *ngIf="demo5 != null" class="video-box col-sm-6 col-md-6">
          <div class="embed-responsive embed-responsive-16by9 ">
            <iframe class="videoURL embed-responsive-item" [src]="demo5" allowfullscreen></iframe>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/research-projects-individual/research-projects-individual.component.html